export const modules = {
    Allocations: "Allocations",
    Admin: "Admin",
    Timesheets: "Timesheets",
    BusinessIntelligence: "BusinessIntelligence",
};

export const BestWorkGroups = {
    BWAdmin: "AC_BESTWORK: ADMINS",
};
